import React, { useEffect, useState } from "react";
import {
  getStaffEditData,
  updateConfig,
} from "../../../store/slices/Staff/staffSlice";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
import {
  staff,
  useGetStaffListDataQuery,
  useUpdateStaffStatusMutation,
  useUpdateStaffTableHeadDataMutation,
} from "../../../store/queries/Staff";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { IconText } from "@wac-ui-dashboard/wac_component_library";
import { deleteStaff } from "../api";
import { toast } from "react-toastify";
import { current } from "@reduxjs/toolkit";

const useStaffList = () => {
  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];
  const [showImageModal, setShowImageModal] = useState(false);
  const [imageData, setImageData] = useState("");
  const dispatch = useDispatch();
  const staffState = useSelector((state) => state.staff);
  const { showEditModal } = useSelector((state) => state.global);
  const {
    data: staffList = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetStaffListDataQuery({
    page_size: staffState?.currentPageSize,
    page: staffState?.currentPage,
    sort: staffState?.sortBy,
    sort_order: staffState?.sortOrder,
    search: staffState?.search,
  });
  const [updateStaffFields] = useUpdateStaffTableHeadDataMutation();
  const [updateStatusStatus] = useUpdateStaffStatusMutation();

  const handleCreateClick = () => {
    dispatch(
      updateConfig((state) => {
        state.showCreateModal = !state.showCreateModal;
        state.imageName = "";
        state.imagePreview = "";
        state.isEdit = false;
      })
    );
  };
  useEffect(() => {
    if (staffState.clearSelection) {
      dispatch(
        updateConfig((state) => {
          state.clearSelection = false;
        })
      );
    }
    // eslint-disable-next-line
  }, [staffState.clearSelection]);
  const handleSearch = (e) => {
    dispatch(
      updateConfig((state) => {
        state.search = e.target.value;
        state.currentPage = 1;
      })
    );
  };
  const handleClearClick = () => {
    dispatch(updateConfig((state) => (state.search = "")));
  };
  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      })
    );
  };

  const handleToggle = (e, data) => {
    const newStatus = data.status === "Active" ? false : true;
    let body = {
      staff_id: data?._id,
      status: newStatus ? 1 : 2,
    };
    updateStatusStatus(body);
    dispatch(
      staff.util.updateQueryData(
        "getStaffListData",
        {
          page_size: staffState?.currentPageSize,
          page: staffState?.currentPage,
          sort: staffState?.sortBy,
          sort_order: staffState?.sortOrder,
          search: staffState?.search,
        },
        (cacheEntry) => {
          let currentCache = { ...current(cacheEntry) };
          const newResult = currentCache.data.result?.map((res) =>
            res._id === data?._id
              ? {
                  ...res,
                  status: data.status === "Active" ? "Deactivated" : "Active",
                }
              : res
          );
          currentCache = {
            ...currentCache,
            data: {
              ...currentCache.data,
              result: newResult,
            },
          };
          return currentCache;
        }
      )
    );
  };

  const getRow = (field, data) => {
    const rows = {
      common: (field, data) => <p className="pro-mb-0">{data[field]}</p>,
      image: (field, data) => {
        return (
          <div className="no-wrap">
            <IconText
              icon={
                <span className="material-symbols-outlined x4">imagesmode</span>
              }
              title={`${"View Photo"}`}
              onClick={() => handleViewImage(data?.image)}
            />
          </div>
        );
      },
      status: (field, data) => {
        const isChecked = data?.status === "Active";
        return (
          <div className="form-check form-switch ">
            <input
              className="form-check-input cursor-pointer"
              type="checkbox"
              role="switch"
              id="flexSwitchCheckDefault"
              checked={isChecked}
              onChange={(e) => handleToggle(e, data)}
            />
          </div>
        );
      },
    };
    return rows?.[field]?.(field, data) ?? rows["common"](field, data);
  };
  const handleSort = (label) => {
    if (staffState.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortOrder = staffState.sortOrder === "asc" ? "desc" : "asc";
        })
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortBy = label;
          state.sortOrder = "asc";
        })
      );
    }
  };
  const handleEditAction = (e) => {
    dispatch(
      updateConfig((state) => {
        state.showCreateModal = true;
        state.selectedId = e?.[0];
        state.isEdit = true;
      })
    );
    dispatch(getStaffEditData(e?.[0]));
  };
  const handleDeleteModal = (e) => {
    dispatch(
      updateConfig((state) => {
        state.showDeleteModal = !state.showDeleteModal;
        state.selectedId = e?.[0];
      })
    );
  };
  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.currentPage = page;
      })
    );
  };
  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.currentPageSize = page_size;
        state.currentPage = 1;
      })
    );
  };
  const closeImageModal = () => {
    setShowImageModal(() => false);
    setImageData("");
  };
  const handleViewImage = (data) => {
    setShowImageModal(() => true);
    setImageData(data);
  };
  const handleDelete = async () => {
    const response = await deleteStaff(staffState.selectedId);
    try {
      if (response?.data?.status_code === 200) {
        toast.success(`Staff deleted successfully`);
        refetch();
        dispatch(
          updateConfig((state) => {
            state.clearSelection = true;
          })
        );
      } else {
        toast.error(`Failed to delete Staff. Please try again.`);
      }
    } catch (error) {
      console.error("Error deleting Sub Admin:", error);
      toast.error(error?.message);
    } finally {
      handleDeleteModal();
    }
  };
  return {
    isLoading,
    imageData,
    isFetching,
    staffList,
    showEditModal,
    staffState,
    showImageModal,
    paginationOptions,
    handleEditColumnsClick,
    updateStaffFields,
    handleDeleteModal,
    handleCreateClick,
    handlePagination,
    handleClearClick,
    handleEditAction,
    closeImageModal,
    handlePageSize,
    handleSearch,
    handleDelete,
    handleSort,
    refetch,
    getRow,
  };
};

export default useStaffList;
